import baseCodeToUnitCode from '@barchart/marketdata-api-js/lib/utilities/convert/baseCodeToUnitCode'
import dayjs from 'dayjs'

import { Endpoints } from '@/constants/endpoints'
import { fromNowOrNow } from '@/utils/format'

export const FUTURES_SYMBOLS = [
  'ZC*0',
  'ZS*0',
  'ZW*0',
  'ZL*0',
  'ZM*0',
  'KE*0',
  'MW*0',
  'ZO*0',
  'ZR*0',
  'LE*0',
  'GF*0',
  'HE*0',
  'RS*0'
]
const NEWS_SOURCES = 'BCNEWS,BCCONT,BCSYND,NASS'

export async function getQuote(symbols: string) {
  try {
    const response = await fetch(
      `${Endpoints.PROXY_WEBAPP_URL}/marketplace-ondemand/getQuote.json?symbols=${symbols}&fields=month,year`
    )

    const jsonResponse = await response.json()
    const quotes = jsonResponse.results

    quotes.forEach((quote: any) => {
      quote.unitCode = baseCodeToUnitCode(Number(quote.unitCode))
    })
    return quotes
  } catch (e) {
    return []
  }
}

function updateDisplayTimes(news: any) {
  return news.map((story: any) => {
    const date = dayjs(story.publishDate, 'YYYY-MM-DD HH:mm:ss Z')
    if (dayjs().diff(date, 'days') > 5) {
      story.displayTime = date.format('ddd MMM DD, HH:mm')
    } else {
      story.displayTime = fromNowOrNow(date)
    }
    return story
  })
}

export async function getNews(count: number, date?: string) {
  const subject = 'FUT.AG,FUT.GRN'
  let endpoint = `${Endpoints.PROXY_WEBAPP_URL}/marketplace-ondemand/getNews.json?displayType=headline&sources=${NEWS_SOURCES}&maxRecords=${count}&barchartClassification=${subject}&fields=preview,publishDate,imageURL`

  if (date) endpoint = `${endpoint}&startDate=${date}`

  try {
    const response = await fetch(endpoint)

    const jsonResponse = await response.json()

    let news = jsonResponse.results

    news = updateDisplayTimes(news)

    return news
  } catch (e) {
    return []
  }
}
